import { UserType } from '../../../application/domain/utils/user.type'
import { Component } from 'react'
import { AccessToken } from '../../../application/domain/models/auth/access.token'
import authService from '../../../services/auth'

interface IPropes {
    readonly expected: UserType | UserType[]
}

export class VerifyUserType extends Component<IPropes> {
    public static validate(expected: UserType | UserType[]): boolean {
        try {
            const accessToken: AccessToken = authService.decodeToken()
            const userType: UserType | undefined = accessToken.sub_type

            if (Array.isArray(expected)) {
                return expected.some((allowedType: UserType) => allowedType === userType)
            }

            return userType === expected
        } catch (err) {
            return false
        }
    }

    public render() {
        const { expected, children } = this.props
        if (VerifyUserType.validate(expected)) {
            return children
        }
        return false
    }
}
